import { useEffect, useRef, useState } from "react";
import { isActivePublicUser } from "../../../util/Scripts";
import Slider from "react-slick";
import IntlMessages from "@util/IntlMessages";

import { Modal } from "../../BP2Components";
import { showTitle } from "../../../util/Scripts";
import { parseFile } from "../../ParseFile/ParseFile";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import BlogCarouselWidget from "../WidgetsSettings/BlogCarousel/BlogCarouselSettingsModal";
import "./BlogCarousel.less";
import { Icon_ChevronLeft, Icon_ChevronRight } from "../../BP2Components/Icons/icons";
import { ThreeItems, OneBigItem, ThreeItemsMultipleDataType } from "./BlogCarouselItemsVariants";
import { getListV2 } from "../../../services/api/Api";
import { getSliderProps } from "./getSliderProps";

const BlogCarousel = ({ value, role, data }) => {
   const [listData, setListData] = useState([]);
   const [columnsList, setColumnsList] = useState([]);
   const [modalVisible, setModalVisible] = useState(false);
   const [modalTitle, setModalTitle] = useState();
   const [modalContent, setModalContent] = useState();

   const widgetRef = useRef();

   const mainContainerSliderRef = useRef();

   // this is width of single slider element in "ThreeItemsMultipleDataType"
   const containerWidth = mainContainerSliderRef?.current?.clientWidth;

   // condition that defines width of each element visable in carousel.
   // same breakPoints are used in settings that defines items ammount on screen (less elements - each one should be larger)
   const elementWidth =
      containerWidth > 687
         ? containerWidth / 3.7
         : containerWidth < 477
           ? containerWidth / 1.08
           : containerWidth / 2.4;

   const sliderProps = getSliderProps(value?.widgetType, containerWidth);

   const openModal = (title = "", content = "") => {
      setModalVisible(true);
      setModalTitle(title);
      setModalContent(content);
   };

   const closeModal = () => {
      setModalVisible(false);
   };

   useEffect(() => {
      const count = value.itemsPerWidget != null ? value.itemsPerWidget : 10;
      if (value.listId != null) {
         getListV2(value.listId, 1, count).then((res) => {
            const responseData =
               (isActivePublicUser() && res.data.getPublicList) || res.data.default;
            setListData(responseData.data);
            setColumnsList(responseData.columns);
            value.columns = responseData.columns;
         });
      } else setListData(null);
   }, [value.listId, value.itemsPerWidget]);

   return (
      <div
         ref={widgetRef}
         className="widget-blogcarousel"
         style={{
            boxShadow: "none",
            ...(value?.hideWidgetBorder && { backgroundColor: "transparent" }),
         }}
      >
         <Widget
            title={
               value.widgetTitle && (
                  <h3 style={{ display: "flex", margin: 0 }}>
                     {showTitle(value.titleTranslationKey, value.widgetTitle, data)}
                  </h3>
               )
            }
            style={{ boxShadow: "none" }}
            className={`${value?.subtitleColumn && "blog-carousel-container"} ${
               value?.hideWidgetBorder && "hidden-widget-background"
            }`}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetId={value.id}
                     widgetName={value.name}
                     icon="setting"
                     deleteIcon="true"
                     children={
                        <BlogCarouselWidget value={value} columns={columnsList} data={data} />
                     }
                  />
               )
            }
         >
            {value.listId ? (
               <div ref={mainContainerSliderRef}>
                  <Slider
                     prevArrow={
                        <Icon_ChevronLeft
                           className="widget-blogcarousel__icon"
                           fill="none"
                           stroke="#000000"
                        />
                     }
                     nextArrow={
                        <Icon_ChevronRight
                           className="widget-blogcarousel__icon"
                           fill="none"
                           stroke="#000000"
                        />
                     }
                     {...sliderProps}
                  >
                     {listData?.map((item) => {
                        if (value?.widgetType === "threeItems" || value?.widgetType === "") {
                           return <ThreeItems item={item} value={value} openModal={openModal} />;
                        } else if (value?.widgetType === "oneBigItem") {
                           return <OneBigItem item={item} value={value} openModal={openModal} />;
                        } else if (value?.widgetType === "multipleDataType") {
                           return (
                              <ThreeItemsMultipleDataType
                                 item={item}
                                 value={value}
                                 openModal={openModal}
                                 elementWidth={elementWidth}
                              />
                           );
                        } else {
                           return null;
                        }
                     })}
                  </Slider>
                  <Modal
                     topBarContent={modalTitle}
                     isOpen={modalVisible}
                     onCancel={closeModal}
                     width={800}
                     height={500}
                  >
                     <div className="blog-carusel-modal">
                        <div
                           className="content"
                           dangerouslySetInnerHTML={{
                              __html: modalContent,
                           }}
                        ></div>
                     </div>
                  </Modal>
               </div>
            ) : (
               <div>
                  <IntlMessages id="blogCarousel.setSettings" />
               </div>
            )}
         </Widget>
      </div>
   );
};

export default BlogCarousel;
